"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableCards = void 0;
const vue_1 = require("vue");
const Card_1 = require("./card/Card");
const CardOrderStorage_1 = require("./CardOrderStorage");
exports.SortableCards = vue_1.default.component('sorted-cards', {
    components: {
        Card: Card_1.Card,
    },
    props: {
        cards: {
            type: Array,
        },
        playerId: {
            type: String,
        },
    },
    data: function () {
        const cache = CardOrderStorage_1.CardOrderStorage.getCardOrder(this.playerId);
        const cardOrder = {};
        const keys = Object.keys(cache);
        let max = 0;
        for (const key of keys) {
            if (this.cards.find((card) => card.name === key) !== undefined) {
                cardOrder[key] = cache[key];
                max = Math.max(max, cache[key]);
            }
        }
        max++;
        for (const card of this.cards) {
            if (cardOrder[card.name] === undefined) {
                cardOrder[card.name] = max++;
            }
        }
        return {
            cardOrder,
            dragCard: undefined,
        };
    },
    methods: {
        getCostSortDirectionIcon: function () {
            const currentSortDirection = localStorage.getItem('costSortDirection');
            if (currentSortDirection === 'asc')
                return '▲';
            if (currentSortDirection === 'desc')
                return '▼';
            return '';
        },
        getNameSortDirectionIcon: function () {
            const currentSortDirection = localStorage.getItem('nameSortDirection');
            if (currentSortDirection === 'asc')
                return '▲';
            if (currentSortDirection === 'desc')
                return '▼';
            return '';
        },
        getSortedCards: function () {
            return CardOrderStorage_1.CardOrderStorage.getOrdered(this.cardOrder, this.cards);
        },
        onDragStart: function (source) {
            this.dragCard = source;
        },
        onDragEnd: function () {
            this.dragCard = undefined;
        },
        onDragOver: function (source) {
            if (this.dragCard !== undefined && source !== this.dragCard) {
                const temp = this.cardOrder[source];
                this.cardOrder[source] = this.cardOrder[this.dragCard];
                this.cardOrder[this.dragCard] = temp;
                CardOrderStorage_1.CardOrderStorage.updateCardOrder(this.playerId, this.cardOrder);
                localStorage.removeItem('costSortDirection');
                localStorage.removeItem('nameSortDirection');
            }
        },
        sortByName: function () {
            const currentSortOrder = localStorage.getItem('nameSortDirection');
            const sortedCards = this.cards.sort((a, b) => {
                if (currentSortOrder === null || currentSortOrder === 'desc') {
                    return a.name > b.name ? 1 : -1;
                }
                else {
                    return a.name > b.name ? -1 : 1;
                }
            });
            if (currentSortOrder === null || currentSortOrder === 'desc') {
                localStorage.setItem('nameSortDirection', 'asc');
            }
            else if (currentSortOrder === 'asc') {
                localStorage.setItem('nameSortDirection', 'desc');
            }
            localStorage.removeItem('costSortDirection');
            for (let i = 0; i < sortedCards.length; i++) {
                this.cardOrder[this.cards[i].name] = i + 1;
                CardOrderStorage_1.CardOrderStorage.updateCardOrder(this.playerId, this.cardOrder);
            }
        },
        sortByCost: function () {
            const currentSortOrder = localStorage.getItem('costSortDirection');
            const sortedCards = this.cards.sort((a, b) => {
                if (currentSortOrder === null || currentSortOrder === 'desc') {
                    return a.calculatedCost > b.calculatedCost ? 1 : -1;
                }
                else {
                    return a.calculatedCost > b.calculatedCost ? -1 : 1;
                }
            });
            if (currentSortOrder === null || currentSortOrder === 'desc') {
                localStorage.setItem('costSortDirection', 'asc');
            }
            else if (currentSortOrder === 'asc') {
                localStorage.setItem('costSortDirection', 'desc');
            }
            localStorage.removeItem('nameSortDirection');
            for (let i = 0; i < sortedCards.length; i++) {
                this.cardOrder[this.cards[i].name] = i + 1;
                CardOrderStorage_1.CardOrderStorage.updateCardOrder(this.playerId, this.cardOrder);
            }
        },
    },
    template: `
  <div>
    <div>
        <button class="btn btn-sort" v-on:click="sortByName">Sort by name {{ getNameSortDirectionIcon() }}</button>
        <button class="btn btn-sort" v-on:click="sortByCost">Sort by cost {{ getCostSortDirectionIcon() }}</button>
    </div>
    <div ref="cardbox" v-for="card in getSortedCards()" :key="card.name" class="cardbox" draggable="true" v-on:dragend="onDragEnd()" v-on:dragstart="onDragStart(card.name)" v-on:dragover="onDragOver(card.name)">
        <Card :card="card"/>
    </div>
  </div>`,
});
//# sourceMappingURL=SortableCards.js.map